import { Decimal } from 'decimal.js';
import { KILO_TO_POUND, UD_DESCRIPTIONS, UD_TYPES } from './constants';
import { getUdDescriptionInGrammarTypeByLang, isCatalogUSA, throwError, toDecimalPlaces } from './utils';

const _poundsToKilos = (m: number) => Number(new Decimal(m).times(KILO_TO_POUND));
const _kilosToPounds = (m: number) => Number(new Decimal(m).div(KILO_TO_POUND));

const UD_TYPES_TO_POUNDS = {
  [UD_TYPES.KILOS]: {
    toPounds: _kilosToPounds,
  },
};

const UD_TYPES_TO_KILOS = {
  [UD_TYPES.POUNDS]: {
    toKilos: _poundsToKilos,
  },
};

type TUdType = UD_TYPES.KILOS | UD_TYPES.POUNDS;

export const toPounds = (value: number, udType: TUdType) => {
  if (!UD_TYPES_TO_POUNDS[udType]) {
    throwError();
  }

  return UD_TYPES_TO_POUNDS[udType].toPounds(value);
};

export const toKilos = (value: number, udType: TUdType) => {
  if (!UD_TYPES_TO_KILOS[udType]) {
    throwError();
  }

  return UD_TYPES_TO_KILOS[udType].toKilos(value);
};

export const toObjectWeightByCatalog = (catalogId: number, value: number, udType: TUdType) => {
  if (!UD_TYPES_TO_POUNDS[udType]) {
    throwError();
  }

  const pounds = isCatalogUSA(catalogId) ? toDecimalPlaces(toPounds(value, udType), 3) : undefined;

  const enDescription = pounds
    ? `${pounds} ${getUdDescriptionInGrammarTypeByLang(pounds, UD_DESCRIPTIONS[UD_TYPES.POUNDS].en)}`
    : `${value} ${getUdDescriptionInGrammarTypeByLang(value, UD_DESCRIPTIONS[udType].en)}`;

  const esDescription = pounds
    ? `${pounds} ${getUdDescriptionInGrammarTypeByLang(pounds, UD_DESCRIPTIONS[UD_TYPES.POUNDS].es)}`
    : `${value} ${getUdDescriptionInGrammarTypeByLang(value, UD_DESCRIPTIONS[udType].es)}`;

  const shortDescription = pounds
    ? `${pounds} ${UD_DESCRIPTIONS[UD_TYPES.POUNDS].short}`
    : `${value} ${UD_DESCRIPTIONS[udType].short}`;

  return {
    value,
    ud: udType,
    description: {
      en: enDescription,
      es: esDescription,
      de: enDescription,
      fr: enDescription,
      it: enDescription,
      us: enDescription,
    },
    shortDescription: {
      en: shortDescription,
      es: shortDescription,
      de: shortDescription,
      fr: shortDescription,
      it: shortDescription,
      us: shortDescription,
    },
  };
};
